import React, {useEffect} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import _ from "lodash";

import { SUCCESS, ERROR} from '@/shared/lifecycleStates';
import ManageEmailSettings from "@/components/ManageEmailSettings";
import ManageSMSSettings from "@/components/ManageSMSSettings";

const mapStateToProps = state => ({
  ...state
})

const mapDispatchToProps = dispatch => ({
})

const useStyles = makeStyles(theme => ({
  root: {
    width: '90%',
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
  },
  completed: {
    color: theme.palette.success[600] + "!important",
  }
}));

function getSteps() {
  return [
    {label: 'Contact by Text', stepStateKey: 'TREAT_TEXT'},
    {label: 'Contact by Email', stepStateKey: 'TREAT_EMAIL'},
  ];
}

function getActiveStep(currentStep){
  if(!currentStep){
    return -1;
  }

  let stepIdx = _.findIndex(getSteps(), function(o){return o.stepStateKey === currentStep});
  if(stepIdx >= 0){
    return stepIdx;
  }
  return -1;
}

function SetupConnect(props) {
  const {stepStates, onStepChange, currentStep } = props;
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(getActiveStep(currentStep));
  const [open, setOpen] = React.useState(false);
  const [loadActionsCalled, setLoadActionsCalled] = React.useState(false);
  const steps = getSteps();

  if(!loadActionsCalled){
    setLoadActionsCalled(true);
  }

  useEffect(() => {
    setActiveStep(getActiveStep(currentStep));
  }, [currentStep]);

  if(open && props.user.inviteUserLifecycleState === ERROR){
    toast(props.user.inviteUserError, {position: "top-center", type: "error"});
  }
  else if(open && props.user.inviteUserLifecycleState === SUCCESS){
    props.inviteUserClear();
    toast.success("Invitation sent!", {position: "top-center"});
    setOpen(false);
  }

  const getStepContent = (step) => {
    // eslint-disable-next-line default-case
    switch (step) {
      case 0:
        return (
            <div>
              <Typography color={"textSecondary"}>Allow clients and patients to text in questions, pictures and other concerns.</Typography>
              <ManageSMSSettings/>
            </div>
        );
      case 1:
        return (
            <div>
              <Typography color={"textSecondary"}>Setup an email inbox to receive correspondence from your clients and patients.</Typography>
              <ManageEmailSettings/>
            </div>
        );
    }
  };

  const selectStep = (stepIdx) => {
    setActiveStep(stepIdx);
    onStepChange(getSteps()[stepIdx].stepStateKey);
  }

  return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep} nonLinear orientation="vertical">
          {steps.map((obj, index) => {
            const stepProps = {};
            const stepLabelProps = {};

            if(stepStates[obj.stepStateKey] && stepStates[obj.stepStateKey].completed){
              stepProps.completed = true;
              stepLabelProps.StepIconProps={
                classes: { root: classes.completed }
              };
            }

            return (<Step key={obj.label} {...stepProps}>
              <StepButton onClick={selectStep.bind(this, index)}><StepLabel {...stepLabelProps}>{obj.label}</StepLabel></StepButton>
              <StepContent>
                <Typography>{getStepContent(index)}</Typography>
              </StepContent>
            </Step>);
          })}
        </Stepper>
      </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SetupConnect);